import { InjectionToken } from "@angular/core";
import { SidebarHelpStandardLinks } from "@logex/framework/lg-layout";
import { Observable } from "rxjs";
import { InfoRecordResponseBase, ResponseMessage } from "./response-message";

export const PATIENTS_COUNT_FORMAT = {
    decimals: 0,
    ceiling: 9999999
};

export const VOLUME_DIFFERENCE_FORMAT = {
    decimals: 0,
    ceiling: 9999999,
    forceSign: true
};

export const COST_DIFFERENCE_FORMAT = {
    decimals: 0,
    ceiling: 999999999.99,
    forceSign: true
};

export const MIXED_FLAGS_STATUS = 255;

export interface IFlagged {
    flag_id: number;
}

export interface IFlaggedWithDetails extends IFlagged {
    flag_user_id_inserted: string;
    flag_date_inserted: string;
    flag_comment?: string | typeof MIXED_FLAGS_STATUS;
}

export interface IFlaggedArgumentsBase {
    flag_id: number;
}

export interface IFlaggedGatewayBase {
    updateFlag<T extends IFlaggedArgumentsBase>(args: T): Observable<ResponseMessage>;
}

export interface UpdateFlagsResponseBase extends InfoRecordResponseBase {
    flag_comment?: string;
}

export interface ICommentExtractor {
    getId: (item: unknown) => string;
    getSubject: (item: unknown) => string;
    getComment: (item: unknown) => string;
}

export interface InfoComment {
    local_comment_last_change_date?: string;
    local_comment_last_change_user_name?: string;
    comment_last_change_date?: string;
    comment_last_change_user_name?: string;
}

export interface IRanked {
    position?: number | undefined;
    number_of_hospitals?: number | undefined;
}
export interface LocalComment {
    id: string;
    name: string;
    comment: string;
    readOnly: boolean;
    lastChangeDate?: string;
    lastChangeUserName?: string;
}

export const standardlinks: SidebarHelpStandardLinks = {
    manual: "https://support.logex.nl/doelmatigheid/doelmatigheidsmonitor/handboek/",
    FAQ: "https://support.logex.nl/doelmatigheid/doelmatigheidsmonitor/veelgestelde-vragen/",
    webinar: "https://support.logex.nl/doelmatigheid/doelmatigheidsmonitor/videos/"
};

export enum PageNavId {
    keyPerformanceIndicators = "kpi",
    bestPractices = "bestPractices",
    processVariation = "processVariation",
    practiceVariation = "practiceVariation",
    monitoring = "monitoring"
}

export class PageKeys {
    static PRACTICE_VAR_PAGE_KEY = "practice-variation";
    static PROCESS_VAR_PAGE_KEY = "process-variation";
    static KPI_PAGE_KEY = "kpi";
}

export const HELP_LINKS = new InjectionToken<SidebarHelpStandardLinks>("HELP_LINKS");
